
import {
  Vue, Component, Watch,
} from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
import { leadRouteCode } from '@/helpers/leadCode';

@Component({
  components: {
    Loading,
  },
})
export default class LegacyView extends Vue {
  loading = true

  legacyUrl = ''

  counter = 0

  @Watch('$route')
  onRouteChanged() {
    this.updateIFrameURL();
  }

  @Watch('legacyUrl')
  onLegacyUrlChanged(val: string) {
    const ifr = document.getElementById('legacyFrame');
    if (ifr) {
      (ifr as any).contentWindow.location.replace(val);
    }
  }

  created() {
    window.addEventListener('message', this.messageListener);
  }

  destroyed() {
    window.removeEventListener('message', this.messageListener);
  }

  mounted() {
    console.log('LegacyView: mounted()'); // eslint-disable-line no-console

    // Aggiorna la data/ora dell'ultima attività dell'utente corrente
    this.$store.dispatch('updateLastActivity');

    this.updateIFrameURL();
  }

  messageListener(event: MessageEvent) {
    if (!event || !event.data || !event.data.name) return;

    switch (event.data.name) {
      case 'LEGACY_APP_LOADED':
        this.loading = false;
        break;

      case 'LEGACY_APP_OPEN_URL':
        this.updateRoute(event.data.value);
        break;

      default:
        break;
    }
  }

  getQueryString(url: Location, field: string) {
    const reg = new RegExp(`[?&]${field}=([^&#]*)`, 'i');
    const str = reg.exec(url.toString());
    return str ? str[1] : null;
  }

  updateRoute(url: Location) {
    // eslint-disable-next-line no-console
    console.log('LegacyView: updateRoute() url =', url);

    // Tolto il permesso di uscire verso Ecobonus Check e i due nomi di rete
    // di vendita del cliente precedente: integrazioni spente, vedi
    // docs/integrazioni-disattivate.md. Le rotte interne del preventivo
    // restano, ma il backend risponde 503 finche' l'integrazione e' spenta.
    if (url.toString().endsWith('/quotation/new')
      || url.toString().endsWith('/recover')) {
      window.location = url;
    } else
    if (url.toString().startsWith('/leads/new-v3?type=standard')) {
      this.$router.push({ name: 'NuovaLead', query: { type: 'standard' } });
    } else
    if (url.toString().startsWith('/leads/new-v3?type=richiesta')) {
      this.$router.push({ name: 'NuovaLead', query: { type: 'richiesta' } });
    } else
    if (url.toString().startsWith('/leads/new-v3?type=ordine')) {
      this.$router.push({ name: 'NuovaLead', query: { type: 'ordine' } });
    } else
    if (url.toString().startsWith('/leads/new-v3?type=configuratore')) {
      const action = this.getQueryString(url, 'action');
      const network = this.getQueryString(url, 'network');
      const query = {
        type: 'configuratore',
      } as {
        type: string;
        action?: string;
        network?: string;
      };
      if (action) query.action = action;
      if (network) query.network = network;
      this.$router.push({ name: 'NuovaLead', query });
    } else
    if (url.toString().startsWith('/leads/new-v3?type=eturnity')) {
      // Apre direttamente l'URL senza fare altro
      window.location = url;
    } else
    if (url.toString().startsWith('/leads/new-v3')) {
      this.$router.push({ name: 'NuovaLead', query: { type: 'standard' } });
    } else
    if (url.toString().startsWith('/leads/new')) {
      this.$router.push({ name: 'NuovaLead', query: { type: 'classica' } });
    } else
    if (url.toString().startsWith('/leads/show')) {
      const reg = new RegExp('^/leads/show/([^&#]*)', 'i');
      const result = reg.exec(url.toString());
      const id = result ? result[1] : null;

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', id);

      if (id) {
        this.$router.push({
          name: 'Lead',
          params: { code: leadRouteCode(id) },
        });
      } else {
        this.$router.push({ name: 'Elenco' });
      }
    } else

    // Documentazione
    if (url.toString() === '/docs') {
      this.$router.push({ name: 'Documentazione' });
    } else

    // Utenti
    if (url.toString() === '/users/new') {
      this.$router.push({ name: 'NuovoUtente' });
    } else
    if (url.toString().startsWith('/users/edit')) {
      const reg = new RegExp('^/users/edit/([^&#]*)', 'i');
      const result = reg.exec(url.toString());
      const id = result ? result[1] : null;

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', id);

      if (id) {
        this.$router.push({ name: 'Utente', params: { id } });
      } else {
        this.$router.push({ name: 'ElencoUtenti' });
      }
    } else
    if (url.toString().startsWith('/users')) {
      const hl = this.getQueryString(url, 'hl');

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', hl);

      if (hl) {
        this.$router.push({ name: 'ElencoUtenti', query: { hl } });
      } else {
        this.$router.push({ name: 'ElencoUtenti' });
      }
    } else

    // Gruppi
    if (url.toString() === '/groups/new') {
      this.$router.push({ name: 'NuovoGruppo' });
    } else
    if (url.toString().startsWith('/groups/edit')) {
      const reg = new RegExp('^/groups/edit/([^&#]*)', 'i');
      const result = reg.exec(url.toString());
      const id = result ? result[1] : null;

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', id);

      if (id) {
        this.$router.push({ name: 'Gruppo', params: { id } });
      } else {
        this.$router.push({ name: 'ElencoGruppi' });
      }
    } else
    if (url.toString().startsWith('/groups')) {
      const hl = this.getQueryString(url, 'hl');

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', hl);

      if (hl) {
        this.$router.push({ name: 'ElencoGruppi', query: { hl } });
      } else {
        this.$router.push({ name: 'ElencoGruppi' });
      }
    } else

    // Reti
    if (url.toString() === '/networks/new') {
      this.$router.push({ name: 'NuovaRete' });
    } else
    if (url.toString().startsWith('/networks/edit')) {
      const reg = new RegExp('^/networks/edit/([^&#]*)', 'i');
      const result = reg.exec(url.toString());
      const id = result ? result[1] : null;

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', id);

      if (id) {
        this.$router.push({ name: 'Rete', params: { id } });
      } else {
        this.$router.push({ name: 'ElencoReti' });
      }
    } else
    if (url.toString().startsWith('/networks')) {
      const hl = this.getQueryString(url, 'hl');

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', hl);

      if (hl) {
        this.$router.push({ name: 'ElencoReti', query: { hl } });
      } else {
        this.$router.push({ name: 'ElencoReti' });
      }
    } else

    // Modelli
    if (url.toString() === '/templates/new') {
      this.$router.push({ name: 'NuovoModello' });
    } else
    if (url.toString().startsWith('/templates/edit')) {
      const reg = new RegExp('^/templates/edit/([^&#]*)', 'i');
      const result = reg.exec(url.toString());
      const id = result ? result[1] : null;

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', id);

      if (id) {
        this.$router.push({ name: 'Modello', params: { id } });
      } else {
        this.$router.push({ name: 'ElencoModelli' });
      }
    } else
    if (url.toString().startsWith('/templates')) {
      const hl = this.getQueryString(url, 'hl');

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', hl);

      if (hl) {
        this.$router.push({ name: 'ElencoModelli', query: { hl } });
      } else {
        this.$router.push({ name: 'ElencoModelli' });
      }
    } else

    // Tag
    if (url.toString() === '/categories/new') {
      this.$router.push({ name: 'NuovaCategoria' });
    } else
    if (url.toString().startsWith('/categories/edit')) {
      const reg = new RegExp('^/categories/edit/([^&#]*)', 'i');
      const result = reg.exec(url.toString());
      const id = result ? result[1] : null;

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', id);

      if (id) {
        this.$router.push({ name: 'Categoria', params: { id } });
      } else {
        this.$router.push({ name: 'ElencoCategorie' });
      }
    } else
    if (url.toString().startsWith('/categories')) {
      const hl = this.getQueryString(url, 'hl');

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', hl);

      if (hl) {
        this.$router.push({ name: 'ElencoCategorie', query: { hl } });
      } else {
        this.$router.push({ name: 'ElencoCategorie' });
      }
    } else

    // Tag
    if (url.toString() === '/tags/new') {
      this.$router.push({ name: 'NuovoTag' });
    } else
    if (url.toString().startsWith('/tags/edit')) {
      const reg = new RegExp('^/tags/edit/([^&#]*)', 'i');
      const result = reg.exec(url.toString());
      const id = result ? result[1] : null;

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', id);

      if (id) {
        this.$router.push({ name: 'Tag', params: { id } });
      } else {
        this.$router.push({ name: 'ElencoTag' });
      }
    } else
    if (url.toString().startsWith('/tags')) {
      const hl = this.getQueryString(url, 'hl');

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', hl);

      if (hl) {
        this.$router.push({ name: 'ElencoTag', query: { hl } });
      } else {
        this.$router.push({ name: 'ElencoTag' });
      }
    } else

    // Checklist
    if (url.toString() === '/checklists/new') {
      this.$router.push({ name: 'NuovaChecklist' });
    } else
    if (url.toString().startsWith('/checklists/edit')) {
      const reg = new RegExp('^/checklists/edit/([^&#]*)', 'i');
      const result = reg.exec(url.toString());
      const id = result ? result[1] : null;

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', id);

      if (id) {
        this.$router.push({ name: 'Checklist', params: { id } });
      } else {
        this.$router.push({ name: 'ElencoChecklist' });
      }
    } else
    if (url.toString().startsWith('/checklists')) {
      const hl = this.getQueryString(url, 'hl');

      // eslint-disable-next-line no-console
      console.log('LegacyView: updateRoute() id =', hl);

      if (hl) {
        this.$router.push({ name: 'ElencoChecklist', query: { hl } });
      } else {
        this.$router.push({ name: 'ElencoChecklist' });
      }
    // eslint-disable-next-line brace-style
    }

    else {
      const hl = this.getQueryString(url, 'hl');
      if (hl) this.$router.replace({ name: 'Elenco', query: { hl } });
      else this.$router.replace({ name: 'Elenco' });
    }
  }

  updateIFrameURL() {
    // eslint-disable-next-line no-console
    console.log('LegacyView: updateIFrameURL()');

    this.loading = true;
    const { name, query, params } = this.$route;

    // eslint-disable-next-line no-console
    console.log('LegacyView: updateIFrameURL() this.$route =', this.$route);

    // eslint-disable-next-line no-unreachable
    switch (name) {
      case 'Elenco':
        this.legacyUrl = '/leads?hideHeader=true';
        break;

      case 'NuovaLead':
        if ('type' in query === false || !query.type) {
          this.legacyUrl = '/leads/new-v3?hideHeader=true';
        } else

        if (query.type === 'classica') {
          // Lead Classica (v1 o v2)
          this.legacyUrl = '/leads/new?hideHeader=true';
        } else

        if (query.type === 'configuratore' && 'action' in query && query.action === 'start') {
          // Avvio diretto del configuratore
          // eslint-disable-next-line no-restricted-globals
          window.location.href = 'network' in query && query.network
            ? `/leads/new-v3?type=configuratore&action=start&network=${query.network}&hideHeader=true`
            : '/leads/new-v3?type=configuratore&action=start&hideHeader=true';
        } else

        if (query.type === 'configuratore') {
          // Avvio diretto del configuratore
          // eslint-disable-next-line no-restricted-globals
          this.legacyUrl = 'network' in query && query.network
            ? `/leads/new-v3?type=configuratore&network=${query.network}&hideHeader=true`
            : '/leads/new-v3?type=configuratore&hideHeader=true';
        } else {
          this.legacyUrl = `/leads/new-v3?type=${query.type}&hideHeader=true`;
        }

        break;

      case 'Profilo':
        this.legacyUrl = '/profile?hideHeader=true';
        break;

      // Documentazione
      case 'Documentazione':
        this.legacyUrl = '/docs?hideHeader=true';
        break;

      // Utenti
      case 'ElencoUtenti':
        this.legacyUrl = 'hl' in query
          ? `/users?hl=${query.hl}&hideHeader=true`
          : '/users?hideHeader=true';
        break;
      case 'NuovoUtente':
        this.legacyUrl = '/users/new?hideHeader=true';
        break;
      case 'Utente':
        this.legacyUrl = `/users/edit/${params.id}?hideHeader=true`;
        break;

      // Gruppi
      case 'ElencoGruppi':
        this.legacyUrl = 'hl' in query
          ? `/groups?hl=${query.hl}&hideHeader=true`
          : '/groups?hideHeader=true';
        break;
      case 'NuovoGruppo':
        this.legacyUrl = '/groups/new?hideHeader=true';
        break;
      case 'Gruppo':
        this.legacyUrl = `/groups/edit/${params.id}?hideHeader=true`;
        break;

      // Reti
      case 'ElencoReti':
        this.legacyUrl = 'hl' in query
          ? `/networks?hl=${query.hl}&hideHeader=true`
          : '/networks?hideHeader=true';
        break;
      case 'NuovaRete':
        this.legacyUrl = '/networks/new?hideHeader=true';
        break;
      case 'Rete':
        this.legacyUrl = `/networks/edit/${params.id}?hideHeader=true`;
        break;

      // Modelli
      case 'ElencoModelli':
        this.legacyUrl = 'hl' in query
          ? `/templates?hl=${query.hl}&hideHeader=true`
          : '/templates?hideHeader=true';
        break;
      case 'NuovoModello':
        this.legacyUrl = '/templates/new?hideHeader=true';
        break;
      case 'Modello':
        this.legacyUrl = `/templates/edit/${params.id}?hideHeader=true`;
        break;

      // Categorie
      case 'ElencoCategorie':
        this.legacyUrl = 'hl' in query
          ? `/categories?hl=${query.hl}&hideHeader=true`
          : '/categories?hideHeader=true';
        break;
      case 'NuovaCategoria':
        this.legacyUrl = '/categories/new?hideHeader=true';
        break;
      case 'Categoria':
        this.legacyUrl = `/categories/edit/${params.id}?hideHeader=true`;
        break;

      // Tag
      case 'ElencoTag':
        this.legacyUrl = 'hl' in query
          ? `/tags?hl=${query.hl}&hideHeader=true`
          : '/tags?hideHeader=true';
        break;
      case 'NuovoTag':
        this.legacyUrl = '/tags/new?hideHeader=true';
        break;
      case 'Tag':
        this.legacyUrl = `/tags/edit/${params.id}?hideHeader=true`;
        break;

      // Checklist
      case 'ElencoChecklist':
        if ('hl' in query) {
          this.legacyUrl = `/checklists?hl=${query.hl}&hideHeader=true`;
        } else {
          this.legacyUrl = '/checklists?hideHeader=true';
        }
        break;
      case 'NuovaChecklist':
        this.legacyUrl = '/checklists/new?hideHeader=true';
        break;
      case 'Checklist':
        this.legacyUrl = `/checklists/edit/${params.id}?hideHeader=true`;
        break;

      default:
        break;
    }
  }
}
